<template>
  <v-container class="px-0 pb-0 pt-5">
    <!-- Checkout texts -->
    <v-row class="align-content-end">
      <v-col cols="12" md="10" offset="0" offset-md="1" class="pt-0">
        <div class="text-left">
          <div>
            <span class="text-checkout-sum">{{ certificate.shortname }}</span>
            <span v-if="Object.keys(certificate.syllabi).length > 1" class="text-checkout-sum"
              >, Syllabus {{ syllabus }}
            </span>
            <span class="text-checkout-details--big pl-1">{{ language }}</span>
            <span class="text-checkout-details--big" v-if="extraTime">
              {{ $t("extra_time_requested") }}
            </span>
          </div>
          <div class="text-checkout-details">
            {{ personalInfo.title }} {{ personalInfo.firstname }} {{ personalInfo.lastname }} {{ personalInfo.title2 }}
          </div>
          <div class="text-checkout-details">
            {{ personalInfo.email }}
          </div>
          <div
            class="text-checkout-details"
            v-if="
              mode &&
              !(
                certificate &&
                certificate.overrides &&
                certificate.overrides.options &&
                certificate.overrides.options.showExamVariant === false
              )
            "
          >
            {{ mode }}
          </div>
          <div class="text-checkout-details">
            {{ datetime }}
            <span v-if="timezone && !selectedLiveExam"> ({{ timezone }})</span>
          </div>
          <div class="text-checkout-details" v-if="city">
            {{ city }}
          </div>
        </div>
        <v-divider class="mt-5" v-if="!noPay && !onlyVoucher && price.basePrice && price.basePrice > 0"></v-divider>
      </v-col>
    </v-row>

    <template v-if="!noPay && !onlyVoucher && price.basePrice && price.basePrice > 0">
      <v-row class="pt-4 align-content-end">
        <v-col cols="7" md="7" offset="0" offset-md="1" class="pt-0 pr-0 pb-0">
          <div class="text-left text-checkout-details">
            {{ certificate.shortname }}
          </div>
        </v-col>
        <v-col cols="5" md="3" class="pt-0 pl-0 pb-0">
          <div class="text-right text-checkout-details">
            {{ price.basePrice.toFixed(decimals) }} {{ price.currency }}
          </div>
        </v-col>
      </v-row>

      <v-row class="align-content-end" v-if="price.studentDiscount">
        <v-col cols="7" md="7" offset="0" offset-md="1" class="pt-0 pr-0 pb-0">
          <div class="text-left text-checkout-details">
            {{ $t("price.student_discount") }}
          </div>
        </v-col>
        <v-col cols="5" md="3" class="pt-0 pl-0 pb-0">
          <div class="text-right text-checkout-details">
            - {{ price.studentDiscount.toFixed(decimals) }} {{ price.currency }}
          </div>
        </v-col>
      </v-row>

      <v-row class="align-content-end" v-if="price.voucherDiscount">
        <v-col cols="7" md="7" offset="0" offset-md="1" class="pt-0 pr-0 pb-0">
          <div class="text-left text-checkout-details">
            {{ $t("price.voucher_discount") }}
          </div>
        </v-col>
        <v-col cols="5" md="3" class="pt-0 pl-0 pb-0">
          <div class="text-right text-checkout-details">
            - {{ price.voucherDiscount.toFixed(decimals) }} {{ price.currency }}
          </div>
        </v-col>
      </v-row>

      <v-row class="align-content-end" v-if="price.vat">
        <v-col cols="7" md="7" offset="0" offset-md="1" class="pt-0 pr-0 pb-0">
          <div class="text-left text-checkout-details">
            {{ $t("price.vat") }}
          </div>
          <v-divider></v-divider>
        </v-col>
        <v-col cols="5" md="3" class="pt-0 pl-0 pb-0">
          <div class="text-right text-checkout-details">+ {{ price.vat.toFixed(decimals) }} {{ price.currency }}</div>
          <v-divider></v-divider>
        </v-col>
      </v-row>

      <v-row class="align-content-end mb-2">
        <v-col cols="7" md="7" offset="0" offset-md="1" class="pt-0 pr-0">
          <div class="text-left text-checkout-sum">
            {{ $t("price.total") }}
          </div>
        </v-col>
        <v-col cols="5" md="3" class="pt-0 pl-0">
          <div class="text-right text-checkout-sum">{{ price.finalPrice.toFixed(decimals) }} {{ price.currency }}</div>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
export default {
  name: "RegInfoSummary",
  data() {
    return {
      certificate: this.$store.getters["registration/certificate"],
      price: this.$store.getters["registration/calculatedPrice"],
      personalInfo: this.$store.getters["registration/personalInfo"],
      extraTime: this.$store.getters["registration/extraTime"],
      noPay: this.$store.getters["registration/noPay"],
      syllabus: this.$store.getters["registration/syllabus"],
      city: this.$store.getters["registration/city"],
    };
  },
  computed: {
    decimals() {
      return this.$store.getters["registration/decimals"];
    },
    onlyVoucher() {
      return this.$store.getters["registration/onlyVoucher"];
    },
    selectedLiveExam() {
      return this.$store.getters["registration/examId"];
    },
    language() {
      return this.$store.getters["registration/languageName"];
    },
    datetime() {
      return this.$store.getters["registration/dateTimeTimezone"];
    },
    timezone() {
      return this.$store.getters["registration/timezone"];
    },
    date() {
      return this.$store.getters["registration/date"];
    },
    time() {
      return this.$store.getters["registration/time"];
    },
    mode() {
      return this.$store.getters["registration/mode"];
    },
  },
};
</script>
